import { useLoggedOutSuppliersPagePageCount } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/useLoggedOutSuppliersPagePageCount";
import { useLoggedOutSuppliersPageZeroIndexedPageNumberQueryParams } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPagePageNumberQueryParams";

export const usePrevAndNextPageNumber = () => {
  const { pageNumber } =
    useLoggedOutSuppliersPageZeroIndexedPageNumberQueryParams();
  const pageCount = useLoggedOutSuppliersPagePageCount() ?? 0;

  const pageNumberStartingWithOne = pageNumber + 1;
  const next = pageNumberStartingWithOne + 1;
  const prev = pageNumberStartingWithOne - 1;

  return {
    prev: prev >= 1 ? prev : undefined,
    next: next <= pageCount ? next : undefined,
  };
};
